export enum LiveWidgetTypes {
	LMT = "LMT",
	LS = "LS",
}
